import * as React from 'react';
import styled from 'styled-components';
import { currentBaseUrl, isUserLoggedIn } from 'src/common/services';
import Navbar from '../../components/CustomNav/CustomNav.Component';
import { Button } from 'reactstrap'
// sharing css with lesson-sent component
import { Redirect } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group'
import Loader from "react-loader";
// services
import {currentLesson, getGeneralSmartTableDataPLApi} from '../../common/services';
import './lessonSent.css';

// styled subcomponents 
const RocketSVG = styled.svg`
    #animate-path {
        opacity: 1;
        animation: animatePath 2s ease-out;
        animation-iterations-count: infinite;
    }

    @keyframes animatePath {
        from {translateX: 30px}
        to {translateX: 100px}
    }
`

export default class LessonSentComponent extends React.Component {
    public state = {
        baseUrl: currentBaseUrl(),
        destination: '',
        toLogin: false,
        toProfile: false, 
        navigate: false,
        loading: true,
        currentAssessment: null
        
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.onProfile = this.onProfile.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.openVideo = this.openVideo.bind(this);
    }

    public onLogout() {
        // handlelogout
        this.setState({toLogin: true});
    }

    public onProfile() {
        // handle to profile
        this.setState({navigate: true, destination: currentBaseUrl() + "profile" })
    }

    public handleClick() {
        // handle submit click event
        // post data to end point
        // routing to the next component

        if(this.state.currentAssessment === null){
            console.log("no assessment");

            this.setState({navigate: true, destination: currentBaseUrl() + "home"});
        }
        
        this.setState({navigate: true, destination: currentBaseUrl() + "proassessment/" + this.state.currentAssessment});
         
    }

    public openVideo() {
        // toggle video modal here
        alert("Waiting for a video");
    }

    public componentDidMount() {
        if(!isUserLoggedIn()){
            this.setState({toLogin: true});
        }

        const currentlesson = currentLesson();

        getGeneralSmartTableDataPLApi("content/postlesson/info?session_key=" + currentlesson.sessionKey, (text) =>
            this.handleAllocationsLoaded(text)
        );
    }

    public handleAllocationsLoaded(res) {
        if (res.code === 200) {
          
          this.setState({
            currentAssessment: res.response.assessment_id,
            loading: false,
          });
        }
        else{
            alert("error occured, go to home and try again");
        }
      }

    public render() {
        if(this.state.toLogin === true) {
           return <Redirect to="/login"/>
        }
        if(this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }

        if (this.state.loading) {
            return <Loader />;
        }
        return(
            <div>
                <Navbar profileParent={this.onProfile} logoutParent={this.onLogout}/>
                <CSSTransition
                    in={true}
                    appear={true}
                    classNames="fade"
                    timeout={800}
                > 
                    <div className="lesson-sent-container">
                    <div className="lesson-sent-content">
                    <h1 className="lesson-sent-title">Your lesson has been sent!</h1>
                    <h2 className= "lesson-sent-description">We are calculating your results</h2>

                    <RocketSVG width="231" height="229" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient x1="86.922%" y1="22.028%" x2="17.306%" y2="79.481%" id="a">
                            <stop stop-color="#3EE9F7" offset="0%"/>
                            <stop stop-color="#ACFF24" offset="100%"/>
                            </linearGradient>
                        </defs>
                        <path id="animate-path" d="M182.074 61.778c0-3.487-1.362-6.762-3.833-9.222a13.133 13.133 0 0 0-9.294-3.825 13.137 13.137 0 0 0-9.294 3.825 12.925 12.925 0 0 0-3.832 9.222c0 3.486 1.36 6.76 3.832 9.222 5.126 5.1 13.462 5.1 18.588 0a12.926 12.926 0 0 0 3.833-9.222zm-28.3-15.129c8.367-8.327 21.98-8.327 30.346 0 4.06 4.04 6.295 9.412 6.295 15.129 0 5.716-2.235 11.089-6.295 15.128-4.183 4.164-9.677 6.245-15.173 6.245-5.495 0-10.99-2.081-15.173-6.245-4.059-4.04-6.295-9.412-6.295-15.128 0-5.717 2.236-11.09 6.295-15.129zM125.45 87.26c-.411 0-.823.157-1.138.47l-27.184 27.053a1.553 1.553 0 0 0-.46 1.106c0 .417.164.809.46 1.104l16.31 16.234a1.615 1.615 0 0 0 2.275 0l27.188-27.056a1.55 1.55 0 0 0 .458-1.104c0-.419-.163-.81-.458-1.106L126.589 87.73a1.613 1.613 0 0 0-1.139-.469zm7.018-5.439l16.312 16.233a9.825 9.825 0 0 1 2.907 7.013 9.824 9.824 0 0 1-2.907 7.011l-27.186 27.055a9.915 9.915 0 0 1-7.018 2.888 9.915 9.915 0 0 1-7.017-2.888L91.249 122.9a9.82 9.82 0 0 1-2.909-7.011 9.82 9.82 0 0 1 2.908-7.012l27.186-27.056c3.869-3.852 10.165-3.852 14.034 0zm78.73-38.135c4.761-13.806 7.962-26.292 9.736-33.96-12.763 2.42-24.186 5.582-34.33 9.13 1.703 3.093 5.067 8.252 11.108 14.265 5.478 5.45 10.303 8.733 13.487 10.565zm-32.957 59.78c13.06-12.998 22.977-33.002 30.092-51.834-3.745-2.01-9.704-5.84-16.499-12.603-7.39-7.355-11.261-13.614-13.119-17.237-31.168 12.285-48.61 27.706-54.402 33.47-21.7 21.595-45.585 59.74-53.724 73.197l31.347 31.197c13.567-8.159 52.375-32.375 76.305-56.19zM62.824 125.194c5.378-8.933 21.833-35.585 39.7-57.861-36.308 7.652-63.44 27.592-80.794 59.406 10.936-4.961 25.605-8.138 41.094-1.545zm40.848 83.088c32.057-17.315 52.126-44.43 59.783-80.745-23.22 18.494-49.392 34.578-58.242 39.873 4.137 9.699 6.342 23.719-1.54 40.872zm-15.324-50.39l-19.212-19.119-5.629 7.848a1.534 1.534 0 0 0 .166 2.011l17.975 17.89a1.615 1.615 0 0 0 2.077.166l7.853-5.58-3.23-3.215zM230.388.71c.49.521.704 1.246.575 1.952-.546 2.997-13.752 73.779-46.842 106.712-3.328 3.312-6.94 6.633-10.728 9.919-1.355 9.04-4.24 25.736-13.676 44.039-12.509 24.26-32.237 42.973-58.636 55.62-1.02.487-1.952.686-2.793.686-1.697 0-3.024-.811-3.965-1.692l-.187.09.08-.191a2.482 2.482 0 0 1-.069-.069c-3.003-2.986-1.563-6.012-.872-7.465.137-.288.352-.681.642-1.204 8.162-14.727 8.95-28.532 2.384-41.13l-7.747 5.508a9.948 9.948 0 0 1-5.77 1.847 9.924 9.924 0 0 1-7.016-2.903l-17.974-17.889a9.853 9.853 0 0 1-1.063-12.777l5.509-7.673c-12.672-6.533-26.55-5.742-41.356 2.393-.52.286-.911.498-1.158.614-.808.378-2.05.96-3.489.96-1.241 0-2.628-.432-4.005-1.805l-.069-.069-.23.098.108-.225c-1.323-1.41-2.477-3.676-.993-6.753 12.709-26.279 31.508-45.914 55.875-58.36 18.214-9.303 34.84-12.204 43.974-13.567a177.177 177.177 0 0 1 7.536-8.02C158.987 8.992 227.791.102 228.481.017c.711-.09 1.418.17 1.908.691zM7.31 203.128l-5.059-5.124 38.277-38.094 5.059 5.123L7.31 203.128zm56.568-18.872l5.059 5.123-38.277 38.095-5.059-5.124 38.277-38.094zm-15.162-8.863l5.059 5.123L5.059 229 0 223.878l48.716-48.485zM35.48 139.395l5.059 5.123-23.116 23.005-5.059-5.122 23.116-23.006zm27.176 72.598l23.116-23.005 5.059 5.123-23.116 23.006-5.059-5.124z" fill="url(#a)" fill-rule="nonzero"/>
                    </RocketSVG>

                    <p>Please, take a post lesson assessment test in the meantime</p>
                    <div className="lesson-sent-buttons">
                    <button className="lesson-sent-button green-button" onClick={this.handleClick}>Start Assessment</button>
                    <button className="lesson-sent-button blue-button" onClick={this.openVideo}>Why take an assessment?</button>

                    </div>
                </div>
                    </div>
                
                </CSSTransition>
            </div>
            
        )
    }
}





// WEBPACK FOOTER //
// ./src/pages/Feedback/lessonSent.Component.tsx